// extracted by mini-css-extract-plugin
module.exports = {"notfound":"notfound_notfound__1rfpy","notfound-text":"notfound_notfound-text__2Og2N","notfound-btn":"notfound_notfound-btn__f6n6q"};